const MAP = {
  "5th Grader": { bg: "#2C7B76", fg: "#F1EADC", img: "/brand/nerd-5th.png", label: "5th Grader" },
  "Chess Club": { bg: "#C08A2E", fg: "#16283C", img: "/brand/nerd-chess.png", label: "Chess Club" },
  "Full Pocket Protector": { bg: "#C0472B", fg: "#F1EADC", img: "/brand/nerd-fpp.png", label: "Full Pocket Protector" },
};

export function NerdBadge({ difficulty, className = "" }) {
  const t = MAP[difficulty] || MAP["5th Grader"];
  return (
    <span
      className={`font-sans inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] ${className}`}
      style={{ background: t.bg, color: t.fg }}
      title={`Nerd Scale: ${t.label}`}
      data-testid={`nerd-badge-${difficulty.replace(/\s+/g, "-").toLowerCase()}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: t.fg }} />
      {t.label}
    </span>
  );
}

// The actual Nerd Scale tier graphic used as a physical, tilted sticker.
export function NerdSticker({ difficulty, width = 96, rotate = 4, className = "" }) {
  const t = MAP[difficulty] || MAP["5th Grader"];
  return (
    <img
      src={t.img}
      alt={`Nerd Scale — ${t.label}`}
      className={`nerd-sticker select-none ${className}`}
      style={{ width, transform: `rotate(${rotate}deg)` }}
      draggable="false"
      data-testid={`nerd-sticker-${difficulty.replace(/\s+/g, "-").toLowerCase()}`}
    />
  );
}
